import React, { useState } from "react"
import { useDebounce } from "use-debounce"

import { useGetJiraFieldOptions } from "@/api/useJira"
import { Select, Spin } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { removeBTags } from "@/molecules/JiraIssueField/helpers"
import { JiraIssueFieldProps } from "@/molecules/JiraIssueField/JiraIssueField.types"

import styles from "../JiraIssueField.module.scss"

export const MultiSelectFetchableField = ({
  field,
  onChange,
  projectId,
  value,
  disabled
}: React.ComponentProps<typeof Select> &
  JiraIssueFieldProps & { value?: string[] }) => {
  const [searchValue, setSearchValue] = useState("")
  const [debouncedSearchValue] = useDebounce(searchValue, 500)
  const { t } = useTranslation("translation", {
    keyPrefix: "jiraIssueModal"
  })

  const { response, isLoading } = useGetJiraFieldOptions(
    {
      q: debouncedSearchValue,
      fieldKey: field.key,
      fieldName: field.name,
      projectId: projectId
    },
    {
      enabled: !!debouncedSearchValue,
      staleTime: 30000,
      gcTime: 60000
    }
  )

  const options =
    response?.data?.map((option) => ({
      label: removeBTags(option.label),
      value: option.value
    })) || []

  return (
    <Select
      showSearch
      mode="tags"
      disabled={disabled}
      value={value}
      onSearch={setSearchValue}
      onChange={(newValue) => {
        onChange?.(newValue, [])
      }}
      filterOption={false}
      loading={isLoading}
      notFoundContent={
        isLoading ? (
          <Spin size="small" className={styles.optionsLoader} />
        ) : debouncedSearchValue ? (
          t("noResults")
        ) : null
      }
      options={options}
    />
  )
}
